import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserRelationshipService } from '../user-relationship.service';
import { UserRelationshipGroup, Privilege, PrivilegeGroup, Relationship , UserRelationshipData} from '../models/UserRelationship';
import { Message, ConfirmationService } from 'primeng/api';
import * as _ from 'lodash';
import { PrivilegeService } from '../privilege.service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';
import { GlobalService } from '../../core/global.service';

@Component({
  selector: 'app-manage-user-relationship',
  templateUrl: './manage-user-relationship.component.html',
  styleUrls: ['./manage-user-relationship.component.scss'],
  providers: [ConfirmationService],
  encapsulation: ViewEncapsulation.None
})
export class ManageUserRelationshipComponent implements OnInit, OnDestroy {

  userRelationshipGroup: UserRelationshipGroup[];
  subscription: Subscription;
  loading = false;
  displayEditDialog = false;
  displayAddDialog = false;
  userRelationshipSelected: UserRelationshipGroup;
  messages: Message[] = [];
  moreDialogData: string;
  displayEditUserAccessDialog: boolean = false;
  confirmHeader: string;
  relationshipSelectedIndex: number = -1;
  displayAddUserAccessDialog: boolean = false;
  relationshipWithAddUserCount: number = 0;
  privilegeMoreData: Privilege[] = [];
  privilegeGroupMoreData: PrivilegeGroup[] = [];
  relationshipWithOutCanAddUser: Relationship[] = [];
  displayInactivateDialog = false;

  constructor(private userRelationshipSvc: UserRelationshipService
    , private confirmationService: ConfirmationService
    , private privilegeSvc: PrivilegeService
    , private _global: GlobalService) { }

  ngOnInit() {
    this.loading = true;
    this.subscription = this.userRelationshipSvc.find()
      .subscribe((user: UserRelationshipGroup[]) => {
        const data = (<any>user).data;
        const currentPersonId = this._global.find((<any>_GlobalNS).paths.PersonId);
        // remove current user(login person) from display
        this.userRelationshipGroup = this.excludeCurrentUserInfo(data, currentPersonId);
        // find count of relationship with 'Add/Edit User' for current user
        this.findAddUserAccessRealtionshipCount(data, currentPersonId);
        this.loading = false;
      });
  }

  editUser(userRelationshipGroup: UserRelationshipGroup): void {
    this.displayEditDialog = true;
    this.userRelationshipSelected = userRelationshipGroup;
  }

  updateUser(userRelationsGroup: UserRelationshipGroup[]): void {
    const data = [...this.userRelationshipGroup];
    if (userRelationsGroup.length) {
      data[this.userRelationshipGroup.indexOf(this.userRelationshipSelected)] = userRelationsGroup[0];
      this.userRelationshipGroup = data;
    } else {
      this.userRelationshipGroup = data.filter((val, i) => i !== this.userRelationshipGroup.indexOf(this.userRelationshipSelected));
    }
    this.ngOnInit();
    this.messages = [{severity: 'success', summary: 'Successfully Updated User ' + userRelationsGroup[0].PersonDetail.Email , detail: ''}];
  }

  addUser(userRelationsGroup: UserRelationshipGroup[]): void {
    this.userRelationshipGroup.unshift(userRelationsGroup[0]);
    this.messages = [{severity: 'success', summary: 'Successfully Added User ' + userRelationsGroup[0].PersonDetail.Email , detail: ''}];
  }

  onMessage(message) {
    this.messages = [{severity: message.severity, summary: message.summary, detail: ''}];
  }

  dialogEditAction(flag: boolean): void {
    this.displayEditDialog = flag;
    this.displayInactivateDialog = flag;
  }

  dialogAddAction(flag: boolean): void {
    this.displayAddDialog = flag;
  }

  showAddDialog(): void {
    this.displayAddDialog = true;
  }

  displayMoreDialog(moreDialog, event, moreDialogDataObj, moreType): void {
    if (moreType === 'ASSETGROUP') {
      this.moreDialogData = this.userRelationshipSvc.assetGroupList(moreDialogDataObj);
    } else if (moreType === 'PRIVILEGES') {
      // Privileges:- display privilges  on hover of '+More'.
      this.privilegeGroupMoreData = this.privilegeSvc.privilegeGroupData(moreDialogDataObj.PrivilegeGroups);
      this.privilegeMoreData =  this.privilegeSvc.uniquePrivilege(moreDialogDataObj.Privileges, this.privilegeGroupMoreData);
    }
    moreDialog.show(event);
  }

  editUserRelationship(userRelationshipGroup: UserRelationshipGroup, partnershipIndex: number): void {
    this.relationshipSelectedIndex  = partnershipIndex;
    this.userRelationshipSelected = userRelationshipGroup;
    this.displayEditUserAccessDialog = true;
  }

  removeUserRelationshipConfirm(userRelationshipGroup: UserRelationshipGroup, partnershipIndex: number): void {
    this.userRelationshipSelected = userRelationshipGroup;
    const message = `Are you sure you want to remove access from Partnership [
    ${ this.userRelationshipSelected.Relationship[partnershipIndex].RelationshipName} ] and Asset Groups of Partner User :
    ${this.userRelationshipSelected.PersonDetail.FirstName} ?`;
    this.confirmHeader = 'Remove Partnership';
    this.confirmationService.confirm({
        message: message,
        accept: () => {
          this.loading = true;
          this.messages = [{severity: 'info', summary: 'Processing Remove Partnership', detail: ''}];
          this.userRelationshipSelected.Relationship.splice(partnershipIndex, 1);
          this.userRelationshipSelected.PersonDetail.LoginEnabled = this.userRelationshipSelected.PersonDetail.IsLocked;
          this.subscription = this.userRelationshipSvc.update([this.userRelationshipSelected])
            .subscribe((user: any) => {
            this.messages = [{
              severity: 'success',
              summary: 'Successfully Updated User ' + userRelationshipGroup.PersonDetail.Email, detail: ''
            }];
          }, error => {
            this.onMessage({severity: 'error', summary: 'Error Occcured while Processing'});
          });
          this.loading = false;
        }
    });
  }

  removeUser(userRelationshipGroup: UserRelationshipGroup): void {
    const data = [...this.userRelationshipGroup];
    this.userRelationshipSelected = userRelationshipGroup;
    const isPrimary = this.isPrimaryContcatUser(this.userRelationshipSelected);
    if (isPrimary) {
      this.inactivateUserRelationship(this.userRelationshipSelected);
    } else {
      const message = `Are you sure you want to Inactivate Partner User:
      ${this.userRelationshipSelected.PersonDetail.FirstName}
      remove their access from all Partnerships and Asset Groups?`;
      this.confirmHeader = 'Inactivate Partner User';
      this.confirmationService.confirm({
          message: message,
          accept: () => {
            this.loading = true;
            this.messages = [{severity: 'info', summary: 'Processing Inactivation', detail: ''}];
            this.userRelationshipSelected.PersonDetail.IsActive = false;
            this.userRelationshipSelected.PersonDetail.LoginEnabled = false;
            this.subscription = this.userRelationshipSvc.update([this.userRelationshipSelected])
              .subscribe((user: any) => {
              this.userRelationshipGroup = data.filter((val, i) => i !== this.userRelationshipGroup.indexOf(this.userRelationshipSelected));
              this.messages = [{
                severity: 'success',
                summary: 'Successfully Updated User ' + userRelationshipGroup.PersonDetail.Email, detail: ''
              }];
            }, error => {
              this.onMessage({severity: 'error', summary: 'Error Occcured while Processing'});
            });
            this.loading = false;
          }
      });
    }
  }

  addUserPartnership(userRelationshipGroup: UserRelationshipGroup): void {
    this.relationshipSelectedIndex  = -1;
    this.displayAddUserAccessDialog = true;
    this.userRelationshipSelected = userRelationshipGroup;
  }

  dialogUserAction(flag: boolean): void {
    this.displayEditUserAccessDialog = flag;
    this.displayAddUserAccessDialog = flag;
  }

  canManageUser(userRelationshipGroup: UserRelationshipGroup): boolean {
    let flag = true;
    userRelationshipGroup =  _.filter(userRelationshipGroup.Relationship, ['IsActiveRelationship', true]);
    flag = (_.find(userRelationshipGroup.Relationship, ['CanAddUser', false]) === undefined) ? true : false;
    return flag;
  }

  /*
  set the count of partnership where the current user has Add/Edit User privilge
  */
  findAddUserAccessRealtionshipCount(userRelationshipGroups: UserRelationshipGroup[], personId: number): void {
    let currentUserRelationshipGroup: UserRelationshipGroup[];
    currentUserRelationshipGroup = userRelationshipGroups.filter(
                              (userRelationshipGroup: UserRelationshipGroup) =>
                              userRelationshipGroup.PersonDetail.PersonId.toString() === personId.toString());
    if (currentUserRelationshipGroup.length > 0) {
      this.relationshipWithAddUserCount = currentUserRelationshipGroup[0].Relationship
        .filter(relatiponship => relatiponship.CanAddUser).length;
        /* find relation with out CanAddUser, to exclude from  Add User Access -
         Relationship Drop Down*/
        this.relationshipWithOutCanAddUser = [];
        currentUserRelationshipGroup[0].Relationship.filter(relatiponship => relatiponship.CanAddUser === false)
          .map((relationship ) => {
            this.relationshipWithOutCanAddUser.push({Id: relationship.Id
              , Company : relationship.Company
              , RelationshipName : relationship.RelationshipName});
        });
    }
  }

  /*
  check already user has access to all partnership or user is inactive
  then hiding the 'add partnership' button
  */
  canAddUserAccess(userRelationshipGroup: UserRelationshipGroup): boolean {
    return (userRelationshipGroup.PersonDetail.IsActive
      && (this.relationshipWithAddUserCount > userRelationshipGroup.Relationship.length)) ? true : false;
  }

  /*
  exclude person details based on personId
  */
  excludeCurrentUserInfo(userRelationshipGroups: UserRelationshipGroup[], personId: number) {
    return userRelationshipGroups.filter((userRelationshipGroup: UserRelationshipGroup) =>
      userRelationshipGroup.PersonDetail.PersonId.toString() !== personId.toString());
  }

  /* check the selected user is a Primary Conact for any of his relationship */
  isPrimaryContcatUser(userRelationshipGroup: UserRelationshipGroup): boolean {
    let flag = true;
    flag = (_.find(userRelationshipGroup.Relationship, ['IsPrimaryContact', true]) === undefined) ? false : true;
    return flag;
  }

  /* display Inactive user popup */
  inactivateUserRelationship(userRelationshipGroup: UserRelationshipGroup): void {
    this.userRelationshipSelected = userRelationshipGroup;
    this.displayInactivateDialog = true;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
